import {CrosswordDataType} from "@/types/crosswords";
import {useFLSFullState} from "@/utils/FLSProvider";
import {CrosswordStateType} from "@/pages/crossword";
import {useEffect} from "react";
import {crosswordStringToBoard, makeBlankBoard} from "@/utils/crossword";


type Props = {
  children: React.ReactNode;
  crossword: CrosswordDataType
}

const CrosswordBuffer = ({ children, crossword }: Props) => {
  const {state, setState} = useFLSFullState<CrosswordStateType>()

  useEffect(() => {
    if (crossword.id !== state.crosswordId) {
      const newBoard = crosswordStringToBoard(crossword.grid)

      setState({
        crosswordId: crossword.id,
        crosswordUserBoard: makeBlankBoard(newBoard),
        crosswordCheckedBoard: makeBlankBoard(newBoard),
        crosswordGameState: 'playing',
        crosswordTimeElapsed: 0,
        crosswordHasCheated: false,
      })
    }
  }, []);

  if (state.crosswordId !== crossword.id) return null
  return children
}

export default CrosswordBuffer